import React from 'react';

import deleteIcon from "../../../../../../../assets/icons/delete.svg"
import copyIcon from "../../../../../../../assets/icons/copy-bold.svg"
import arrowForwardUpRightIcon from "../../../../../../../assets/icons/open-bold.svg"
import editIcon from "../../../../../../../assets/icons/edit-bold.svg"
import { Icon } from '../../../../../../Icon/styles';
import {
  PopoverContainer,
  UrlDisplay,
  UrlText,
  MenuOptions,
  MenuButton,
  ButtonIcon
} from './styles';

interface LinkPopoverComponentProps {
  href: string;
  text: string;
  onEdit: (text: string, href: string) => void;
  onClose: () => void;
  onDelete: () => void;
}


export const LinkPopoverComponent: React.FC<LinkPopoverComponentProps> = ({
  href,
  text,
  onEdit,
  onClose,
  onDelete
}) => {
  return (
    <PopoverContainer>
      <UrlDisplay>
        <UrlText title={href}>
          {href.length > 40 ? `${href.substring(0, 40)}...` : href}
        </UrlText>
      </UrlDisplay>

      <MenuOptions>
        <MenuButton onClick={() => window.open(href, "_blank")}>
          <ButtonIcon>
            <Icon icon={arrowForwardUpRightIcon} size="16px" color="black" />
          </ButtonIcon>
          Abrir enlace
        </MenuButton>

        <MenuButton
          onClick={() => {
            onEdit(text, href);
            onClose();
          }}
        >
          <ButtonIcon>
            <Icon icon={editIcon} size="16px" color="black" />
          </ButtonIcon>
          Editar enlace
        </MenuButton>

        <MenuButton
          onClick={() => {
            navigator.clipboard.writeText(href);
            onClose();
          }}
        >
          <ButtonIcon>
            <Icon icon={copyIcon} size="16px" color="black" />
          </ButtonIcon>
          Copiar enlace
        </MenuButton>

        <MenuButton
          isDelete
          onClick={() => {
            onDelete();
            onClose();
          }}
        >
          <ButtonIcon>
            <Icon icon={deleteIcon} size="16px" color="#e74c3c" />
          </ButtonIcon>
          Eliminar enlace
        </MenuButton>
      </MenuOptions>
    </PopoverContainer>
  );
};
